import { identity } from '@kofno/piper';
import { Decoder, field, number, oneOf, stringLiteral, succeed } from 'jsonous';
import { readonlyArray } from '../../../../../Decoders';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import { formTemplatesDecoder } from '../../../../../Resource/FormTemplates/Decoders';
import { licenseResourceDecoder } from '../../Table/LicenseAllocations/Decoders';
import {
  BulkParticipantsLicenseFormPayload,
  BulkParticipantsLicenseFormResource,
  NewBulkLicenseAllocationsPayload,
  NewBulkLicenseAllocationsResource,
  ParticipantBulkLicenseSubmittedPayload,
  ParticipantBulkLicenseSubmittedResource,
  ParticipantLicenseAction,
  SubmissionResponse,
  SubmissionSuccess,
  ValidationErrors,
} from './Types';

export const newBulkLicenseAllocationsPayloadDecoder: Decoder<NewBulkLicenseAllocationsPayload> =
  succeed({});

export const newBulkLicenseAllocationsResourceDecoder: Decoder<NewBulkLicenseAllocationsResource> =
  resourceDecoder(newBulkLicenseAllocationsPayloadDecoder).assign('templates', ({ links }) =>
    field('templates', formTemplatesDecoder(links)),
  );

const participantLicenseActionDecoder: Decoder<ParticipantLicenseAction> = oneOf([
  stringLiteral<ParticipantLicenseAction>('allocate'),
  stringLiteral<ParticipantLicenseAction>('release'),
]);

export const participantBulkLicenseSubmittedPayloadDecoder: Decoder<ParticipantBulkLicenseSubmittedPayload> =
  succeed({})
    .assign(
      'allocatedOrReleasedLicenses',
      field('allocated_or_released_licenses', readonlyArray(licenseResourceDecoder)),
    )
    .assign('userIds', field('user_ids', readonlyArray(number)))
    .assign('licenseAction', field('license_action', participantLicenseActionDecoder))
    .map<ParticipantBulkLicenseSubmittedPayload>(identity);

export const participantBulkLicenseSubmittedResourceDecoder: Decoder<ParticipantBulkLicenseSubmittedResource> =
  resourceDecoder(participantBulkLicenseSubmittedPayloadDecoder);

export const bulkParticipantsLicenseFormPayloadDecoder: Decoder<BulkParticipantsLicenseFormPayload> =
  succeed({}).assign(
    'allocatableOrReleasableLicenses',
    field('allocatable_or_releasable_licenses', readonlyArray(licenseResourceDecoder)),
  );

export const bulkParticipantsLicenseFormResourceDecoder: Decoder<BulkParticipantsLicenseFormResource> =
  resourceDecoder(bulkParticipantsLicenseFormPayloadDecoder).assign('templates', ({ links }) =>
    field('templates', formTemplatesDecoder(links)),
  );

export const submissionSuccessDecoder: Decoder<SubmissionSuccess> =
  participantBulkLicenseSubmittedResourceDecoder.map((resource) => ({
    kind: 'submission-success',
    resource,
  }));

export const validationErrorsDecoder: Decoder<ValidationErrors> =
  bulkParticipantsLicenseFormResourceDecoder.map((resource) => ({
    kind: 'validation-errors',
    resource,
  }));

export const submissionResponseDecoder: Decoder<SubmissionResponse> = oneOf<SubmissionResponse>([
  submissionSuccessDecoder.map<SubmissionResponse>(identity),
  validationErrorsDecoder.map<SubmissionResponse>(identity),
]);
